import React, { useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { saveDoctor } from '../../../../actions/admin/doctor';
import { DOCTOR_FIELDS_ERR_1, DOCTOR_INIT } from '../../../../constants/admin/doctor_constants';

//MUI
import {
    Avatar, Box, Container, Grid, Typography,
    Alert, Button, Checkbox, FormControl, FormControlLabel, TextField
} from '@mui/material';
import CameraAltIcon from '@mui/icons-material/CameraAlt';

const name_regex = /^([^0-9]*)$/;
const email_regex = /^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/;
const tel_regex = /^[0-9]*$/;

const NewDirectory = () => {
    const navigate = useNavigate();

    // valores
    const [values, setValues] = useState(DOCTOR_INIT);
    const { name, lastname, email, phone, ced, speciality,
        sub_speciality, hospital, hospital_type, state, mun, colony } = values;
    // errores 
    const [inputErr, setInputErr] = useState(DOCTOR_FIELDS_ERR_1);
    const { name_err, lastname_err, email_err, phone_err, ced_err, speciality_err,
        sub_speciality_err, hospital_err, hospital_type_err, state_err, mun_err, colony_err } = inputErr;

    const name_ref = useRef();
    const lastname_ref = useRef();
    const email_ref = useRef();
    const phone_ref = useRef();
    const ced_ref = useRef();
    const speciality_ref = useRef();
    const sub_speciality_ref = useRef();
    const hospital_ref = useRef();
    const hospital_type_ref = useRef();
    const state_ref = useRef();
    const mun_ref = useRef();
    const colony_ref = useRef();

    const handleInputChange = ({ target }) => {
        const name = target.name;
        const value = target.value;
        if (name === 'name' || name === 'lastname') {
            if (value === '' || name_regex.test(value)) {
                setValues(e => ({
                    ...e,
                    [name]: value
                })
                );
            }
        } else if (name === 'phone') {
            if (value === '' || tel_regex.test(value)) {
                setValues(e => ({
                    ...e,
                    [name]: value
                })
                );
            }
        } else setValues(e => ({
            ...e,
            [name]: value
        })
        );
        switch (name) {
            case 'name':
                setInputErr({
                    ...inputErr,
                    name_err: (value.length < 2 ||
                        value.length > 150) ? true : false
                });
                break;
            case 'lastname':
                setInputErr({
                    ...inputErr,
                    lastname_err: (value.length < 2 ||
                        value.length > 255) ? true : false
                });
                break;
            case 'email':
                setInputErr({
                    ...inputErr,
                    email_err: (value.length < 3 ||
                        value.length > 150) ? true : false
                });
                break;
            case 'phone':
                setInputErr({
                    ...inputErr,
                    phone_err: (value.length < 6 ||
                        value.length > 100) ? true : false
                });
                break;
            case 'ced':
                setInputErr({
                    ...inputErr,
                    ced_err: (value.length > 0 && value.length < 2 ||
                        value.length > 30) ? true : false
                });
                break;
            case 'speciality':
                setInputErr({
                    ...inputErr,
                    speciality_err: (value.length > 0 && value.length < 2 ||
                        value.length > 150) ? true : false
                });
                break;
            case 'sub_speciality':
                setInputErr({
                    ...inputErr,
                    sub_speciality_err: (value.length > 0 && value.length < 2 ||
                        value.length > 150) ? true : false
                });
                break;
            case 'hospital':
                setInputErr({
                    ...inputErr,
                    hospital_err: (value.length > 0 && value.length < 2 ||
                        value.length > 255) ? true : false
                });
                break;
            case 'hospital_type':
                setInputErr({
                    ...inputErr,
                    hospital_type_err: (value.length > 0 && value.length < 2 ||
                        value.length > 100) ? true : false
                });
                break;
            case 'state':
                setInputErr({
                    ...inputErr,
                    state_err: (value.length > 0 && value.length < 2 ||
                        value.length > 100) ? true : false
                });
                break;
            case 'mun':
                setInputErr({
                    ...inputErr,
                    mun_err: (value.length > 0 && value.length < 2 ||
                        value.length > 255) ? true : false
                });
                break;
            case 'colony':
                setInputErr({
                    ...inputErr,
                    colony_err: (value.length > 0 && value.length < 2 ||
                        value.length > 255) ? true : false
                });
                break;
            default:
                break;
        }
    };

    const [preview, setPreview] = useState();
    const [imageFile, setImageFile] = useState(null);
    const [registerCoupon, setRegisterCoupon] = useState(false);
    const handleChange = (e) => {
        const selected = e.target.files?.[0] || null;
        setImageFile(selected);
        setPreview(selected ? URL.createObjectURL(selected) : undefined);
    };

    // const handleDelete = () => {
    //     setFile();
    // };

    const formValidator = () => {
        const errors = {
            ...DOCTOR_FIELDS_ERR_1,
            name_err: name.trim().length < 2 || name.trim().length > 150,
            lastname_err: lastname.trim().length < 2 || lastname.trim().length > 255,
            email_err: !email_regex.test(email.trim()) || email.trim().length > 150,
            phone_err: phone.trim().length < 6 || phone.trim().length > 100,
            ced_err: Boolean(ced) && (ced.trim().length < 2 || ced.trim().length > 30),
            speciality_err: Boolean(speciality) && speciality.trim().length < 2,
            sub_speciality_err: Boolean(sub_speciality) && sub_speciality.trim().length < 2,
            hospital_err: Boolean(hospital) && hospital.trim().length < 2,
            hospital_type_err: Boolean(hospital_type) && hospital_type.trim().length < 2,
            state_err: Boolean(state) && state.trim().length < 2,
            mun_err: Boolean(mun) && mun.trim().length < 2,
            colony_err: Boolean(colony) && colony.trim().length < 2
        };
        setInputErr(errors);
        const firstInvalid = [
            ['name_err', name_ref], ['lastname_err', lastname_ref],
            ['email_err', email_ref], ['phone_err', phone_ref], ['ced_err', ced_ref],
            ['speciality_err', speciality_ref], ['sub_speciality_err', sub_speciality_ref],
            ['hospital_err', hospital_ref], ['hospital_type_err', hospital_type_ref],
            ['state_err', state_ref], ['mun_err', mun_ref], ['colony_err', colony_ref]
        ].find(([key]) => errors[key]);
        firstInvalid?.[1]?.current?.focus();
        return !firstInvalid;
    };

    const submit = async (e) => {
        e.preventDefault();
        if (formValidator()) {
            const req = await saveDoctor(values, imageFile);
            if (req.status) {
                navigate('/nefro-admin/directorio-medico', {
                    state: registerCoupon ? { couponDoctor: req.resp.doctor } : {}
                });
            }
        }
    };

    return (
        <Container maxWidth='lg' sx={{ mb: 5 }} style={{ marginTop: '90px' }}>
            <Typography variant='h5' sx={{ mb: 3 }}>Nuevo médico</Typography>
            <Box px={5} py={5} boxShadow='0 2px 4px 2px rgb(0 0 0 / 20%)' borderRadius='8px'>
                <Box textAlign='center' mb={3}>
                    <input
                        accept="image/*"
                        type="file"
                        id="select-image_directory"
                        name="images"
                        style={{ display: 'none' }} onChange={handleChange}
                    />
                    <label htmlFor="select-image_directory">
                        <Avatar src={preview}
                            sx={{
                                width: '140px', height: '140px', cursor: 'pointer', bgcolor: '#fff',
                                boxShadow: '0 2px 4px 2px rgb(0 0 0 / 20%)'
                            }}
                        >
                            <CameraAltIcon fontSize='large' sx={{ color: '#000' }} />
                        </Avatar>
                    </label>
                </Box>

                <Typography variant='body1' gutterBottom sx={{ fontWeight: '600' }}>Información personal</Typography>
                <Grid container spacing={2}>
                    {/* Nombre */}
                    <Grid item xl={6} lg={6} md={6} sm={12} xs={12}>
                        <FormControl fullWidth>
                            <TextField
                                variant="outlined"
                                label='Nombre'
                                size='small'
                                name="name"
                                error={name_err}
                                helperText={name_err ? "Ingrese el nombre" : ""}
                                inputRef={name_ref}
                                value={name}
                                onChange={handleInputChange}
                            />
                        </FormControl>
                    </Grid>

                    {/* Apellidos */}
                    <Grid item xl={6} lg={6} md={6} sm={12} xs={12}>
                        <FormControl fullWidth>
                            <TextField
                                variant="outlined"
                                label='Apellidos'
                                size='small'
                                name="lastname"
                                error={lastname_err}
                                helperText={lastname_err ? "Ingrese los apellidos" : ""}
                                inputRef={lastname_ref}
                                value={lastname}
                                onChange={handleInputChange}
                            />
                        </FormControl>
                    </Grid>

                    {/* e-mail */}
                    <Grid item xl={6} lg={6} md={6} sm={12} xs={12}>
                        <FormControl fullWidth>
                            <TextField
                                variant="outlined"
                                label='Correo electrónico'
                                size='small'
                                name="email"
                                error={email_err}
                                helperText={email_err ? "Ingrese el correo electrónico" : ""}
                                inputRef={email_ref}
                                value={email}
                                onChange={handleInputChange}
                            />
                        </FormControl>
                    </Grid>

                    {/* teléfono */}
                    <Grid item xl={6} lg={6} md={6} sm={12} xs={12}>
                        <FormControl fullWidth>
                            <TextField
                                variant="outlined"
                                label='Teléfono'
                                size='small'
                                name="phone"
                                error={phone_err}
                                helperText={phone_err ? "Ingrese el número de teléfono" : ""}
                                inputRef={phone_ref}
                                value={phone}
                                onChange={handleInputChange}
                            />
                        </FormControl>
                    </Grid>
                </Grid>

                <Typography variant='body1' gutterBottom sx={{ fontWeight: '600', mt: 3 }}>
                    Información médica (opcional)
                </Typography>
                <Grid container spacing={2}>
                    {/* Cedula */}
                    <Grid item xl={6} lg={6} md={6} sm={12} xs={12}>
                        <FormControl fullWidth>
                            <TextField
                                variant="outlined"
                                label='Cédula profesional'
                                size='small'
                                name="ced"
                                error={ced_err}
                                helperText={ced_err ? "Ingrese la cédula profesional" : ""}
                                inputRef={ced_ref}
                                value={ced}
                                onChange={handleInputChange}
                            />
                        </FormControl>
                    </Grid>

                    {/* especialidad */}
                    <Grid item xl={6} lg={6} md={6} sm={12} xs={12}>
                        <FormControl fullWidth>
                            <TextField
                                variant="outlined"
                                label='Especialidad'
                                size='small'
                                name="speciality"
                                error={speciality_err}
                                helperText={speciality_err ? "Ingrese la especialidad" : ""}
                                inputRef={speciality_ref}
                                value={speciality}
                                onChange={handleInputChange}
                            />
                        </FormControl>
                    </Grid>

                    {/* subespecialidad */}
                    <Grid item xl={6} lg={6} md={6} sm={12} xs={12}>
                        <FormControl fullWidth>
                            <TextField
                                variant="outlined"
                                label='Subespecialidad'
                                size='small'
                                name="sub_speciality"
                                error={sub_speciality_err}
                                helperText={sub_speciality_err ? "Ingrese la sub-especialidad" : ""}
                                inputRef={sub_speciality_ref}
                                value={sub_speciality}
                                onChange={handleInputChange}
                            />
                        </FormControl>
                    </Grid>

                    {/* hospital */}
                    <Grid item xl={6} lg={6} md={6} sm={12} xs={12}>
                        <FormControl fullWidth>
                            <TextField
                                variant="outlined"
                                label='Hospital'
                                size='small'
                                name="hospital"
                                error={hospital_err}
                                helperText={hospital_err ? "Ingrese el hospital" : ""}
                                inputRef={hospital_ref}
                                value={hospital}
                                onChange={handleInputChange}
                            />
                        </FormControl>
                    </Grid>

                    {/* tipo hospital */}
                    <Grid item xl={6} lg={6} md={6} sm={12} xs={12}>
                        <FormControl fullWidth>
                            <TextField
                                variant="outlined"
                                label='Tipo hospital'
                                size='small'
                                name="hospital_type"
                                error={hospital_type_err}
                                helperText={hospital_type_err ? "Ingrese el tipo de hospital" : ""}
                                inputRef={hospital_type_ref}
                                value={hospital_type}
                                onChange={handleInputChange}
                            />
                        </FormControl>
                    </Grid>

                    {/* estado */}
                    <Grid item xl={6} lg={6} md={6} sm={12} xs={12}>
                        <FormControl fullWidth>
                            <TextField
                                variant="outlined"
                                label='Estado'
                                size='small'
                                name="state"
                                error={state_err}
                                helperText={state_err ? "Ingrese el estado" : ""}
                                inputRef={state_ref}
                                value={state}
                                onChange={handleInputChange}
                            />
                        </FormControl>
                    </Grid>

                    {/* municipio */}
                    <Grid item xl={6} lg={6} md={6} sm={12} xs={12}>
                        <FormControl fullWidth>
                            <TextField
                                variant="outlined"
                                label='Municipio'
                                size='small'
                                name="mun"
                                error={mun_err}
                                helperText={mun_err ? "Ingrese el municipio" : ""}
                                inputRef={mun_ref}
                                value={mun}
                                onChange={handleInputChange}
                            />
                        </FormControl>
                    </Grid>

                    {/* Colonia */}
                    <Grid item xl={6} lg={6} md={6} sm={12} xs={12}>
                        <FormControl fullWidth>
                            <TextField
                                variant="outlined"
                                label='Colonia'
                                size='small'
                                name="colony"
                                error={colony_err}
                                helperText={colony_err ? "Ingrese la colonia" : ""}
                                inputRef={colony_ref}
                                value={colony}
                                onChange={handleInputChange}
                            />
                        </FormControl>
                    </Grid>

                    <Grid item xs={12}>
                        <Alert severity="info">
                            Nombre, apellidos, correo y teléfono son los únicos datos obligatorios.
                            La fotografía y la información médica pueden completarse después.
                        </Alert>
                        <FormControlLabel
                            sx={{ mt: 1 }}
                            control={
                                <Checkbox
                                    checked={registerCoupon}
                                    onChange={event => setRegisterCoupon(event.target.checked)}
                                />
                            }
                            label="Registrar también su cupón médico después de guardar"
                        />
                    </Grid>
                    <Grid item xs={12} sx={{display: 'flex', justifyContent: 'flex-end'}}>
                        <Button variant='contained' onClick={submit} sx={{textTransform: 'none'}}>Guardar</Button>
                    </Grid>
                </Grid>
            </Box>
        </Container >
    )
}

export default NewDirectory
